RivalIQ.apps.Admin.apps.Company.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.CustomerChangeRequests = Marionette.CompositeView.extend({
        template: '#adminCompanyCustomerChangeRequestsTemplate',
        childView: views.CustomerChangeRequest,
        childViewContainer: 'tbody'
    });
});
